/* import EHcore from './js/EHcore.js' */
var common = require("./common.js");
var core = require("./EHcore.js");
var Calcu_02 = core.Calcu_02

import Vue from 'vue';
import web from './webhelper.js';

import hdchart from './vue/chart/index.vue'
import radio from './vue/radio.vue'
import status from './vue/status.vue'
import line from './vue/line.vue'
import select from './vue/select.vue'
import number from './vue/number.vue'
import inputpanel from './vue/input-panel.vue'
import outputpanel from './vue/output-panel.vue'
import outputuml from './vue/output-uml.vue'
import calcumethodsselect from './vue/calcumethods-select.vue'
import dialog from './vue/dialog.vue'
import note from './vue/note.vue'

Vue.component('my-component-hdchart', hdchart)
Vue.component('my-component-radio', radio)
Vue.component('my-component-status', status)
Vue.component('my-component-line', line)
Vue.component('my-component-select', select)
Vue.component('my-component-number', number)
Vue.component('my-component-input-panel', inputpanel)
Vue.component('my-component-output-panel', outputpanel)
Vue.component('my-component-output-uml', outputuml)
Vue.component('my-component-calcumethods-select', calcumethodsselect)
Vue.component('my-component-dialog', dialog)
Vue.component('my-component-note', note)
var vm;
/*下面的参数都需要在iniCanvas中用到*/
var atm = 101.325;//这个一会还需要优化
//默认夏季输入参数
var inputParm_s_default = {
	desc: '夏季默认输入',
	selected: false,
	value: {
		nStatus: { id: 1, desc: '夏季室内状态点', type: 'status', mark: 'n', isActive: false, value: Calcu_02(26, 50, atm) },
		//室外温度
		wStatus: { id: 2, desc: '夏季室外状态点', type: 'status', mark: 'w', isActive: false, value: Calcu_02(33.2, 58.93, atm) },
		//室外温度
		Q: { value: 4.36, unit: 'Kw', conversion: 1, step: 0.01, min: 0, desc: '冷负荷', type: 'number' },
		//余热（kj/s）conversion:计算用值和实际值的差距
		W: { value: 0.000295, unit: 'mg/s', conversion: 1000000, step: 0.001, min: 0, desc: '湿负荷', type: 'number' },
		//余湿（kg/s）
	}
}
//默认冬季输入参数
var inputParm_w_default = {
	desc: '冬季默认输入',
	selected: false,
	value: {
		nStatus: { id: 1, desc: '冬季室内状态点', type: 'status', mark: 'n', isActive: false, value: Calcu_02(26, 50, atm) },
		//室外温度
		wStatus: { id: 2, desc: '冬季室外状态点', type: 'status', mark: 'w', isActive: false, value: Calcu_02(0, 50, atm) },
		//室外温度
		Q: { value: 4.36, unit: 'Kw', step: 0.01, conversion: 1, min: 0, desc: '热负荷', type: 'number' },
		//余热（kj/s）
		W: { value: 0.000295, unit: 'mg/s', step: 0.01, conversion: 1000000, min: 0, desc: '湿负荷', type: 'number' },
		//余湿（kg/s）
	}
}
//下面这两个参数需要在canvas中使用，整合canvas时，可以写入内部。
//计算方法
import calcuMethods from './calcuMethods.js';

//注册该指令后，对象可以移动
import mymove from './vue/directive/v-mymove.js'
Vue.directive('mymove', mymove)
//注册该指令后，对象可以接受移动的对象
import mymovedestination from './vue/directive/v-mymovedestination.js'
Vue.directive('mymovedestination', mymovedestination)
//v-myico:toggle-on.before=""
import mynumber from './vue/directive/v-mynumber.js'
Vue.directive('mynumber', mynumber)
vm = new Vue({
	el: '#app',
	data: {
		ui_congigure: { showPanel: true, },
		filename: '未命名',
		info: '',
		//焓湿图配置
		hdconfigure: {
			isreflesh: false,//控制是否重新生成画布
			width: 800,
			minwidth: 500,
			maxwidth: 2000,
			atm: atm,
			minatm: 90,
			maxatm: 150,
			hiddenimg: false,
			hiddentooltip: false,
			hiddensummberres: false,//隐藏夏季
			hiddenwinterres: false,//隐藏冬季
			transparency: 0.3,//背景透明度
			temperatureParm: { l: -10, h: 50, StrokeColor: '#ec322e' },
			dampnessParm: { l: 0, h: 40, StrokeColor: '#337ab7' },
			enthalpyParm: { l: -20, h: 140, StrokeColor: '#f16205' },
			RhParm: { StrokeColor: '#1d1c1c' },
			toolTipsParm: { StrokeColor: '#272626', TextColor: '#272626', StatusColor: '#3198f1', LineColor: '#3198f1' },
		},
		//默认输入
		inputParm_s_default: inputParm_s_default,
		inputParm_w_default: inputParm_w_default,
		//计算方法列表
		calcuMethods: calcuMethods,
		//当前空气状态点
		curStatusData: {
			desc: '当前状态点',
			type: 'status',
			mark: 'i',
			isActive: false,
			value: Calcu_02(22, 60, atm)
		},
		curLine: null,
		//当前方法
		curMethod: null,
		//对话框
		//反馈
		feedbackDialog: {
			name: '反馈',
			value: {
				email: '', username: '', message: '',
			},
			display: false
		},
		//加载
		loadingDialog: {
			name: '加载', display: false
		},
		//对话框
		confirmDialog: {
			name: '对话框', desc: '', display: false
		},
		HchartDialog: {
			name: '焓湿图设置', display: false
		},
	},
	mounted: function () {
		// var errorObj=document.getElementsByClassName('numerror');
		/* console.log('mounted')
		UI.get('feedback/counter/',function(res){
			console.log('get',res.val())
		})
		var obj={
			url:'feedback/1278154346@qq',
			field:'email',
			startValue:'1278154346@qq.com',
			limitnum:5,
			order:true,//顺序、逆序
			callback:function(res){
			   console.log('find',res.val())
			}
		}
		UI.find(obj) */
	},
	watch: {
		info: function (val) {
			if (val != '') {
				var _this = this;
				setTimeout(function () { _this.info = '' }, 3000);
			}
		}
	},
	methods: {
		changeMethod: function (event) {
			var curMethodId = event.target.value
			if (curMethodId != -1) {
				this.curMethod = this.calcuMethods[curMethodId]
			} else {
				this.curMethod = null;
			}
		},
		calcu: function () {
			if (this.curMethod && typeof this.curMethod.calcu == 'function') {
				//需要把夏季、冬季、还有大气压都传过去
				this.curMethod.calcu(this.inputParm_s_default, this.inputParm_w_default, this.hdconfigure.atm)
			} else {
				console.log('该方法中未定义calcu函数')
			}
		},
		//改变空气处理过程（line）
		changeLine: function (event) {
			//说明鼠标在该组件上
			this.curLine = event;
		},
		//改变湿空气状态点
		changeStatus: function (event) {
			//console.log('changeStatus',event)
			this.curStatusData.value = event.value;
			this.curStatusData.mark = event.mark;
			this.curStatusData.isActive = event.isActive;//先试试		
		},
		//该函数用来管理全局的Ui方法
		UImethod: function (methodname) {
			var _this = this;
			console.log('这里可以执行全局行的ui方法', methodname)
			if (methodname == 'showFeedbackDialog') {
				this.feedbackDialog.display = true;
			} else if (methodname == 'submitFeedback') {
				var myvalid = common.isValid(_this.feedbackDialog.value, [{ name: 'email', type: 'email' }, { name: 'message', min: 10 }])
				if (!myvalid.value) {
					_this.info = myvalid.errors
					console.log('数据不合法')
					return;
				}
				this.showLoading(function () {
					_this.feedbackDialog.value.createtime = common.getNowFormatDate();
					web.add('feedback', _this.feedbackDialog.value, function (res) {
						console.log('submitFeedback:', res);
						_this.info = '提交成功'
						_this.closeLoading();
					});
				});
			} else if (methodname == 'getFeedback') {
				var handle = common.debounce(function () {
					var obj = {
						url: 'feedback', field: 'email',
						callback: function (res) {
							var val = res.val();
							if (val) {
								for (var p in val) {
									_this.feedbackDialog.value = val[p]
								}
							}
							console.log('getFeedback', res.val())
						}
					}
					obj.startValue = _this.feedbackDialog.value.email;
					web.find(obj)
				}, 500, true);
				handle();
			} else if (methodname == 'showHchartDialog') {//这个需要在显示前，设置一下
				this.HchartDialog.oldValue = common.deepCopy(this.hdconfigure);//用于还原
				this.HchartDialog.display = true;
			} else if (methodname == 'savePNG') {
				this.showLoading(function () {
					var img = _this.$refs.hdchart_main.canvas.toDataURL();
					common.savePNG(_this.filename, img);//这里还可以很方便的传入名字
					_this.closeLoading();
				});
				//this.showLoading(false);
			} else if (methodname == 'saveSVG') {
				common.saveSVG(this.filename);//这里还可以很方便的传入名字
			}
		},
		showLoading: function (cb) {
			this.loadingDialog.display = true;
			if (cb && typeof cb == 'function') {
				setTimeout(cb, 50);
			}
		},
		closeLoading: function () {
			this.loadingDialog.display = false;
		},
		//控制菜单用的
		popMenu: function (event) {
			//console.log(event,res)
			var ul = event.currentTarget.children[1];
			//console.log(event.type)
			var type = event.type
			if (type == 'mouseenter') {
				ul.style.display = "block";
				event.stopPropagation();
			} else if (type == 'mouseleave') {
				ul.style.display = "none";
				event.stopPropagation();
			} else if (type == 'click') {//兼容手机
				ul.style.display = ul.style.display != 'none' ? 'none' : 'block';
				event.stopPropagation();
			}
		},
	}
})




// WEBPACK FOOTER //
// ./src/main.js